export class KeyboardController {
  constructor(scene, playerCharacter) {
    this._scene = scene;
    this._playerCharacter = playerCharacter;

    // map default controls
    this.controlScheme = scene.game.keymap.controlKeyMap;
    this.keys = scene.input.keyboard.addKeys(
      Object.keys(this.controlScheme)
        .map((k) => this.controlScheme[k])
        .join(',')
    );
  }

  enable() {
    this._scene.input.keyboard.on('keydown', this.handleKeyDown, this);
  }

  disable() {
    this._scene.input.keyboard.off('keydown', this.handleKeyDown, this);
  }

  handleKeyDown(e) {
    switch (e.key) {
      case this.controlScheme['JUMP']:
        this._playerCharacter.jump();
        break;
      case this.controlScheme['ATTACK']:
        this._playerCharacter.attack();
        break;
      case this.controlScheme['SPECIAL']:
        this._playerCharacter.special();
        break;
    }
  }

  getMovementDirection() {
    const dir = { x: 0, y: 0 };
    if (this.keys[this.controlScheme['LEFT']].isDown) dir.x--;
    if (this.keys[this.controlScheme['RIGHT']].isDown) dir.x++;
    if (this.keys[this.controlScheme['UP']].isDown) dir.y--;
    if (this.keys[this.controlScheme['DOWN']].isDown) dir.y++;
    return dir;
  }
}
